//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../Preferences/Preferences.SessionPreferences.js";
let d=[[[0,"DispSceneLabels",1,0],[0,"DispSeeThru",1,0],[0,"ExcludeFromSelection",1,0]],[[[],"GetDirectoryOfStudioMaterial",{R_:{studio_material_directory:''}},0,0],[["studio_material_directory"],"SetDirectoryOfStudioMaterial",{},1,0],[[],"GetDirectoryOfTexture",{R_:{texture_dir:''}},0,1],[["texture_dir"],"SetDirectoryOfTexture",{},1,1]],[]];
SPLM.Preferences.SessionAppearanceMgrPreference = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.SessionAppearanceMgrPreference";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;